/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  FormControl,
  FormHelperText,
  Grid,
  List,
  ListItem,
  Typography,
  ListItemText,
  Alert, Tooltip,
} from "@deere/fuel-react";
import { DataGrid } from "@mui/x-data-grid";
import { Controller } from "react-hook-form";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import "../assets/Campaigns.scss";
import { sortAlphaNum } from "../shared/utils";
import { useAuthConfig } from "../shared/helper";
import { Loading } from "../shared/Loading";
import PropTypes from "prop-types";
import {Block} from "@material-ui/icons";

export const CampaignCriteria = ({
  control,
  onSelect,
  currentData,
  onSelectStep,
  supplierFunctionalArea,
  supplierSubFunctionalArea,
  isCriteriaError,
  ratingTeam,
}) => {
  let authAxios = useAuthConfig();
  const [categoriesList, setCategoriesList] = useState([]);
  const [stakeholders, setStakeholders] = useState([]);
  const [criteriaList, setCriteriaList] = useState([]);
  const [selectQuality, setSelectedQuality] = useState([]);
  const [selectDelivery, setSelectedDelivery] = useState([]);
  const [selectProcessAlignment, setSelectedProcessAlignment] = useState([]);
  const [selectRelationship, setSelectedRelationship] = useState([]);
  const [selectValueCreation, setSelectedValueCreation] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingDataGrid, setIsLoadingDataGrid] = useState(true);
  const [categoryId, setCategoryId] = useState(1);
  const [categoryName, setCategoryName] = useState("Quality");
  const [selectedCategoryId, setSelectedCategoryId] = useState(0);
  const selectedCriteria = [
    ...selectQuality,
    ...selectDelivery,
    ...selectProcessAlignment,
    ...selectRelationship,
    ...selectValueCreation,
  ];
  const [functionalAreas, setFunctionalAreas] = useState([]);
  const [subFunctionalAreas, setSubFunctionalAreas] = useState([]);
  const [selectedFunctionalAreas, setSelectedFunctionalAreas] = useState([
    supplierFunctionalArea,
  ]);
  const [selectedSubFunctionalAreas, setSelectedSubFunctionalAreas] = useState([
    supplierSubFunctionalArea,
  ]);

  const getCategories = async () => {
    try {
      return await authAxios.get(`/categories`);
    } catch (e) {
      console.error(e);
    }
  };

  const getStakeholders = async () => {
    try {
      return await authAxios.get(
        `/stakeholders?functionalAreaCodes=` +
          supplierFunctionalArea.description
      );
    } catch (e) {
      console.error(e);
    }
  };

  const getCriteriaCatalog = async () => {
    try {
      const data = {
        categories: [1, 2, 3, 4, 5],
        status: "active",
        functionalGroupId: supplierFunctionalArea.id,
        subFunctionalGroupId: supplierSubFunctionalArea.id,
      };
      return await authAxios.post(
        `/criteria/search/${currentData.fiscalYear}`,
        data
      );
    } catch (e) {
      console.error(e);
    }
  };

  const handleSelectedCategory = (id, name) => {
    setCategoryId(id);
    setCategoryName(name);
    setSelectedCategoryId(id - 1);
  };

  const handleRowSelection = (data, e) => {
    if (categoryId === 1) {
      setSelectedQuality(e);
    } else if (categoryId === 2) {
      setSelectedDelivery(e);
    } else if (categoryId === 3) {
      setSelectedProcessAlignment(e);
    } else if (categoryId === 4) {
      setSelectedRelationship(e);
    } else if (categoryId === 5) {
      setSelectedValueCreation(e);
    }
    onSelect(categoryId, data);
  };

  const handleChangeValues = (value, id) => {
    const updatedRows = criteriaList.map((row) => {
      if (row.id === id) {
        row.stakeholders = [...value];
      }
      return row;
    });
    const mergedSelectedData = [
      ...selectQuality,
      ...selectDelivery,
      ...selectProcessAlignment,
      ...selectRelationship,
      ...selectValueCreation,
    ];
    const updateSelectedRows = updatedRows.filter(
      (item) => mergedSelectedData.indexOf(item.id) > -1
    );
    onSelect(categoryId, updateSelectedRows);
    setCriteriaList(updatedRows);
  };

  // Also gets the sub functional areas too
  const getFunctionalArea = async () => {
    try {
      return await authAxios.get(`/functional-areas`);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (currentData.qualityCriteriaData && currentData.qualityCriteriaData.length > 0) {
      setSelectedQuality(currentData.qualityCriteriaData);
    }
    if (currentData.deliverCriteriaData && currentData.deliverCriteriaData.length > 0) {
      setSelectedDelivery(currentData.deliverCriteriaData);
    }
    if (currentData.processAlignmentCriteriaData && currentData.processAlignmentCriteriaData.length > 0) {
      setSelectedProcessAlignment(currentData.processAlignmentCriteriaData);
    }
    if (currentData.relationshipCriteriaData && currentData.relationshipCriteriaData.length > 0) {
      setSelectedRelationship(currentData.relationshipCriteriaData);
    }
    if (currentData.valueCreationCriteriaData && currentData.valueCreationCriteriaData.length > 0) {
      setSelectedValueCreation(currentData.valueCreationCriteriaData);
    }

    onSelectStep(1);
    getCategories().then((res) => {
      setCategoriesList(res.data);
      setIsLoading(false);
    });
    getStakeholders().then((res) => {
      setStakeholders(res.data);
    });
    getFunctionalArea().then((res) => {
      setFunctionalAreas(res.data);
      setSubFunctionalAreas(
          res.data.map((i) => i.subFunctionalArea.map((j) => j)).flat()
      );
    });
    getCriteriaCatalog().then((res) => {
      if (currentData.criteriaSelectedData) {
        for (let item1 of res.data) {
          for (let item2 of currentData.criteriaSelectedData) {
            if (item1.id === item2.id) {
              item1.stakeholders = item2.stakeholders;
            }
          }
        }
      }
      setCriteriaList(res.data);
      if (
        currentData.criteriaSelectedData.length === 0 &&
        currentData.functionalArea &&
        currentData.functionalArea !== ""
      ) {

        let selectedSubFuncAreas =
          selectedSubFunctionalAreas &&
          selectedSubFunctionalAreas.map((item) => item.id);

        const filterFunctionalArea =
          res.data &&
          res.data.filter((item) => {
            const currentSubFunctionalAreas = item.subFunctionalAreas.map(
              (sfa) => sfa.id
            );
            return (
              selectedSubFuncAreas &&
              selectedSubFuncAreas.some((ele) =>
                  currentSubFunctionalAreas.includes(ele)
              )
            );
          });
        const qualityFilterData =
          filterFunctionalArea &&
          filterFunctionalArea.filter((item) => item.category.id === 1);
        setSelectedQuality(
          qualityFilterData.map((item) => {
            return item.id;
          })
        );
        onSelect(1, qualityFilterData);

        const deliveryFilterData =
          filterFunctionalArea &&
          filterFunctionalArea.filter((item) => item.category.id === 2);
        setSelectedDelivery(
          deliveryFilterData.map((item) => {
            return item.id;
          })
        );
        onSelect(2, deliveryFilterData);

        const processAllignmentFilterData =
          filterFunctionalArea &&
          filterFunctionalArea.filter((item) => item.category.id === 3);
        setSelectedProcessAlignment(
          processAllignmentFilterData.map((item) => {
            return item.id;
          })
        );
        onSelect(3, processAllignmentFilterData);

        const relationshipFilterData =
          filterFunctionalArea &&
          filterFunctionalArea.filter((item) => item.category.id === 4);
        setSelectedRelationship(
          relationshipFilterData.map((item) => {
            return item.id;
          })
        );
        onSelect(4, relationshipFilterData);

        const valueCreationFilterData =
          filterFunctionalArea &&
          filterFunctionalArea.filter((item) => item.category.id === 5);
        setSelectedValueCreation(
          valueCreationFilterData.map((item) => {
            return item.id;
          })
        );
        onSelect(5, valueCreationFilterData);

        setIsLoading(false);
      }
      setIsLoadingDataGrid(false);
      setIsLoadingDataGrid(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentData, selectedFunctionalAreas, selectedSubFunctionalAreas]);

  const columns = [
    {
      field: "id",
      headerName: "ID",
      hide: true,
    },
    // {
    //   field: "ratingProgram",
    //   headerName: "In Program",
    //   flex: 0.4,
    //   renderCell: (params) => {
    //     let ratingProgram = params.value;
    //     return (
    //       <>
    //         <Typography size="sm" component="p" className="wrap-text">
    //           {ratingProgram}
    //         </Typography>
    //       </>
    //     );
    //   },
    // },
    {
      field: "subCategory",
      headerName: "Sub-Category",
      flex: 0.50,
      renderCell: (params) => {
        let subCategory = params.value;
        return (
          <>
            <Typography size="sm" component="p" className="wrap-text">
              {subCategory}
            </Typography>
          </>
        );
      },
    },
    {
      field: "criteria",
      headerName: "Criteria",
      flex: 0.95,
      renderCell: (params) => {
        let criteria = params.value;
        return (
          <>
            <Typography size="sm" component="p" className="wrap-text">
              {criteria}
            </Typography>
          </>
        );
      },
    },
    {
      field: "stakeholderType",
      headerName: "Suggested Stakeholder Type",
      flex: 0.82,
      renderCell: (params) => {
        return (
          <Autocomplete
            size="small"
            multiple
            limitTags={1}
            options={stakeholders}
            defaultValue={params.row.stakeholders}
            value={params.row.stakeholders}
            getOptionLabel={(option) => option.description}
            getOptionSelected={(option, value) =>
              option.description === value.description
            }
            style={{ paddingTop: 5, width: "95%" }}
            onChange={(e, value) => {
              handleChangeValues(value, params.row.id);
            }}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" />
            )}
          />
        );
      },
    },
  ];

  let selectedSubFuncAreas =
    selectedSubFunctionalAreas[0] &&
    selectedSubFunctionalAreas.map((item) => item.id);
  const filterFunctionalArea =
    criteriaList &&
    criteriaList.filter((item) => {
      const currentSubFunctionalAreas = item.subFunctionalAreas.map(
        (sfa) => sfa.id
      );
      return (
        selectedSubFuncAreas &&
        selectedSubFuncAreas.some((ele) =>
          currentSubFunctionalAreas.includes(ele)
        )
      );
    });

  const sortedData =
    criteriaList &&
    criteriaList.sort((a, b) => {
      let descA = a.criteria.toLowerCase(),
        descB = b.criteria.toLowerCase();
      return sortAlphaNum(descA, descB);
    });

  const rowsData =
    sortedData &&
    filterFunctionalArea &&
    filterFunctionalArea
      .filter((item) => item.category.id === categoryId)
      .map((item) => {
        return {
          id: item.id,
          ratingProgram:
            item.ratingProgram === "Y" &&
            item.subFunctionalAreas.find(
              (sfa) => sfa.id === supplierSubFunctionalArea.id
            ) &&
            item.functionalAreas.find(
              (fa) => fa.id === supplierFunctionalArea.id
            )
              ? "YES"
              : "NO",
          subCategory: item.subCategory && item.subCategory.description,
          criteria: item.criteria,
          stakeholders: item.stakeholders,
        };
      });

  const rolesIncludedInCriteria = Array.from(
    new Set(
      filterFunctionalArea
        .map((item) => item.stakeholders.map((stakeholder) => stakeholder.id))
        .flat()
    )
  );

  const ratingTeamMembersNotIncluded = ratingTeam.filter(
    (teamMember) =>
      !rolesIncludedInCriteria.includes(Number(teamMember.role.id))
  );

  return (
    <Grid container>
      <Grid item xs={12}>
        <Box sx={{ mr: 6, mt: 6 }}>
          {!!ratingTeamMembersNotIncluded.length && (
            <Alert
              title="The following members/roles are not included in this criteria. To include, add these roles to appropriate questions."
              variant="warning"
            >
              <ul>
                {ratingTeamMembersNotIncluded.map((teamMember, index) => {
                  console.log(teamMember)
                  return (
                    <li key={`ratingTeamMember-${index}`}>
                      <span style={{display: "flex", alignItems: "center", gap: "5px"}}>{teamMember.name} ({teamMember.role.description}) {teamMember.userStatus && teamMember.userStatus !== "ACTIVE" && <Tooltip title={"Invalid User ID"}><Block htmlColor={"red"} /></Tooltip>}</span>
                    </li>
                  );
                })}
              </ul>
            </Alert>
          )}
        </Box>
      </Grid>
      <Grid item xs={2}>
        <Box mt={6} mb={2} style={{ position: "sticky", top: 80 }}>
          <Card>
            <CardContent style={{ padding: 0 }}>
              <Box mt={2}>
                <Grid container alignItems="flex-start" spacing={2}>
                  <Grid item xs={12}>
                    {isLoading && <Loading />}
                    {!isLoading && (
                      <List
                        disablePadding
                        component="nav"
                        aria-label="category list"
                      >
                        {categoriesList.map((item, index) => {
                          return (
                            <ListItem
                              button
                              divider={categoriesList.length !== index + 1}
                              selected={index === selectedCategoryId}
                              key={index}
                              className="feedback-List"
                              onClick={() => {
                                handleSelectedCategory(
                                  item.id,
                                  item.description
                                );
                              }}
                            >
                              <ListItemText
                                primary={
                                  <React.Fragment>
                                    <Grid container>
                                      <Grid item xs={10}>
                                        <Typography
                                          color="primary"
                                          size="md"
                                          component="span"
                                          fontWeight="semibold"
                                        >
                                          {item.description}
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={2}>
                                        <Box
                                          display="flex"
                                          justifyContent="flex-end"
                                        >
                                          <Typography>
                                            {/*{selectedCriteria.length}*/}
                                            {item.id === 1
                                              ? selectQuality.length
                                              : ""}
                                            {item.id === 2
                                              ? selectDelivery.length
                                              : ""}
                                            {item.id === 3
                                              ? selectProcessAlignment.length
                                              : ""}
                                            {item.id === 4
                                              ? selectRelationship.length
                                              : ""}
                                            {item.id === 5
                                              ? selectValueCreation.length
                                              : ""}
                                          </Typography>
                                        </Box>
                                      </Grid>
                                    </Grid>
                                  </React.Fragment>
                                }
                              />
                            </ListItem>
                          );
                        })}
                      </List>
                    )}
                  </Grid>
                </Grid>
              </Box>
            </CardContent>
          </Card>
        </Box>
      </Grid>
      <Grid item xs={10}>
        <Box m={6}>
          <Card>
            <CardContent style={{ padding: 0 }}>
              <Box mt={2}>
                <Grid container alignItems="flex-start" spacing={3}>
                  <Grid item xs={8} md={4}>
                    <Box ml={4}>
                      <Typography variant="h4">
                        {/*{selectedCriteria.length}*/}
                        {categoryId === 1 ? `(${selectQuality.length})` : ""}
                        {categoryId === 2 ? `(${selectDelivery.length})` : ""}
                        {categoryId === 3
                          ? `(${selectProcessAlignment.length})`
                          : ""}
                        {categoryId === 4
                          ? `(${selectRelationship.length})`
                          : ""}
                        {categoryId === 5
                          ? `(${selectValueCreation.length})`
                          : ""}{" "}
                        {categoryName} Criteria Included
                      </Typography>
                    </Box>
                  </Grid>
                  {
                    // supplierSubFunctionalArea && supplierFunctionalArea ? (
                    //   <Grid item xs={16} md={8} container direction='row'>
                    //       <Grid item xs={12} md={6} style={{paddingRight: '.5em'}}>
                    //           <AutoCompleteCheckbox
                    //             name={"functionalAreas"}
                    //             label={"Functional Area"}
                    //             showLabel={false}
                    //             options={functionalAreas}
                    //             control={control}
                    //             defValue={selectedFunctionalAreas}
                    //             onOptionsChange={handleFunctionalArea}
                    //             required={true}
                    //           />
                    //       </Grid>
                    //       <Grid item xs={12} md={6} style={{paddingRight: '.5em'}}>
                    //           <AutoCompleteCheckbox
                    //             limitTags={3}
                    //             name={"subFunctionalAreas"}
                    //             label={"Sub-Functional Area"}
                    //             showLabel={false}
                    //             options={subFunctionalAreas}
                    //             control={control}
                    //             defValue={selectedSubFunctionalAreas}
                    //             onOptionsChange={handleSubFunctionalArea}
                    //             required={true}
                    //           />
                    //       </Grid>
                    //   </Grid>
                    // ) : <></>
                  }
                  <Grid item xs={12}>
                    <Box m={2}>
                      <FormControl
                        required
                        fullWidth
                        error
                        style={{ height: "400px" }}
                      >
                        {isLoadingDataGrid && <Loading />}
                        {!isLoadingDataGrid && (
                          <Controller
                            rules={{ required: true }}
                            control={control}
                            defaultValue={selectedCriteria}
                            value={selectedCriteria}
                            name="selectedCriteriaValue"
                            render={({ onChange, value }) => (
                              <DataGrid
                                rows={rowsData}
                                columns={columns}
                                // checkboxSelection
                                disableSelectionOnClick
                                hideFooter
                                disableColumnSelector={true}
                                disableColumnFilter
                                className="criteriaList"
                                onSelectionModelChange={(ids) => {
                                  const selectedIDs = new Set(ids);
                                  const selectedRowData = rowsData.filter(
                                    (row) => selectedIDs.has(row.id)
                                  );
                                  onChange(selectedRowData, ids);
                                  handleRowSelection(selectedRowData, ids);
                                }}
                                selectionModel={(() => {
                                  if (categoryId === 1) {
                                    return selectQuality;
                                  } else if (categoryId === 2) {
                                    return selectDelivery;
                                  } else if (categoryId === 3) {
                                    return selectProcessAlignment;
                                  } else if (categoryId === 4) {
                                    return selectRelationship;
                                  } else if (categoryId === 5) {
                                    return selectValueCreation;
                                  }
                                })()}
                              />
                            )}
                          />
                        )}
                        {isCriteriaError && (
                          <FormHelperText>
                            Please select minimum one criteria
                          </FormHelperText>
                        )}
                      </FormControl>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </CardContent>
          </Card>
        </Box>
      </Grid>
    </Grid>
  );
};

CampaignCriteria.propTypes = {
  control: PropTypes.any,
  currentData: PropTypes.shape({
    criteriaSelectedData: PropTypes.array,
    deliverCriteriaData: PropTypes.any,
    functionalArea: PropTypes.string,
    processAlignmentCriteriaData: PropTypes.any,
    qualityCriteriaData: PropTypes.any,
    relationshipCriteriaData: PropTypes.any,
    valueCreationCriteriaData: PropTypes.any,
  }),
  isCriteriaError: PropTypes.any,
  supplierFunctionalArea: PropTypes.any,
  supplierSubFunctionalArea: PropTypes.any,
  onSelect: PropTypes.func,
  onSelectStep: PropTypes.func,
  ratingTeam: PropTypes.array,
};
